import { AppNode } from "@features/builder/graph/types"
import { useNodesParentsLinkedNodes } from "@features/builder/hooks/useNodeParentsLinkedNodes"
import { NodeFormValues } from "@features/builder/NodeDrawer/NodeForm"
import { convertNodeBasedOnFormValues } from "@features/builder/NodeDrawer/NodeForm/helpers"
import { useNodes } from "@xyflow/react"
import { useMemo } from "react"

type UseNodeBasedOnFormValuesProps = {
  nodeId: string
  values: NodeFormValues
}

export const useNodeBasedOnFormValues = (props: UseNodeBasedOnFormValuesProps) => {
  const allNodes = useNodes<AppNode>()

  const originalNode = allNodes.find((node) => node.id === props.nodeId)
  const parentsLinkedNodesMap = useNodesParentsLinkedNodes(originalNode)

  const nodeBasedOnForm = useMemo(() => {
    if (!originalNode) return

    return convertNodeBasedOnFormValues(originalNode, allNodes, props.values, parentsLinkedNodesMap)
  }, [allNodes, props.values, originalNode, parentsLinkedNodesMap])

  return nodeBasedOnForm
}
